export const en = {
    'failed-to-load-banners-for-popup': 'Unable to load banners. Please try again'
};
